import React  from "react";
import { useEffect, useState } from 'react';
import {Button,Card,Form,Container,Row,Col} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import ListadoActividadFecha from "components/Elements/ListadoActividadFecha";
import {useActividades} from '../hooks/useActividades';
import {useActividadesFecha} from '../hooks/useActividadesFecha';

function EditarActividad(){
  const parametros = useParams();
  const { actividadPorActualizar,setActividadPorActualizar,updateActividad,
    updateRespuestaActualizarActividad,respuestaActualizarActividad,getActividad} = useActividades(parametros.actividadId);

    //const {getActividadesFecha} = useActividadesFecha(parametros.actividadId);
  
  const [isChangedElements,setChange]=useState(false);

  //const [aF,setAF]=useState([]);
  
const actualizarActividad = async() => {
  setChange(false);
  const resp=await updateActividad(actividadPorActualizar);
  setChange(true);
};

useEffect( () => {
  async function EditarActividadFuncion(){
    getActividad();
  }
  EditarActividadFuncion();
  
}, []); 

/*
useEffect( () => {
 
  async function EditarActividadFuncion(){
    const actividadesFecha=await getActividadesFecha();
    setAF(actividadesFecha);
  
  }
  EditarActividadFuncion();
}); */

useEffect( () => {
    async function EditarActividadFuncion(){
    updateRespuestaActualizarActividad
  }
  EditarActividadFuncion();
}, [isChangedElements]);

  return (
    <>
      <Container fluid>
      <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Actividad</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col xs="6">
                  <label>Nombre</label>
                  <Form.Control
                    value={actividadPorActualizar?.Nombre}
                    placeholder=""
                    type="text"
                   onChange={(e,prop) => { 
                      setActividadPorActualizar({...actividadPorActualizar,['Nombre']:e.target.value});
                    }}
                    rows={12}>
                  </Form.Control>
                  </Col>
                  <Col xs="6">
                  <label>Sigla</label>
                  <Form.Control
                    value={actividadPorActualizar?.Sigla}
                    placeholder=""
                    type="text"
                   onChange={(e,prop) => { 
                      setActividadPorActualizar({...actividadPorActualizar,['Sigla']:e.target.value});
                    }}
                    rows={12}>
                  </Form.Control>
                  </Col>
                </Row>
                           
                <Row>
                  <Col xs="12">
                    <label>Descripción</label>
                    <Form.Control
                      value={actividadPorActualizar?.Descripcion}
                      placeholder=""
                      type="textarea"
                      as="textarea"
                      onChange={(e,prop) => { 
                        setActividadPorActualizar({...actividadPorActualizar,['Descripcion']:e.target.value});
                      }}
                      rows={12}>
                    </Form.Control>
                              
                   </Col>
                              
                </Row>
                <MensajeAlerta mensajeTexto={respuestaActualizarActividad.mensajeTexto} estado={respuestaActualizarActividad.estado} />
                <Row>
                  <Col xs="6">
                  </Col>
                  <Col xs="6">
                    <br></br>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                                       e.preventDefault();
                                       actualizarActividad();
                        }}>
                        Actualizar Actividad
                      </Button>
                      <br></br>
                  </Col>
                  </Row>
                  <br></br>
                  <br></br>
                  {/*<Row>
                    <Col>
                    <h4>Listado Fechas</h4>
                    <ListadoActividadFecha data={aF}></ListadoActividadFecha>
                    </Col>
                    
                      </Row>*/}

              </Card.Body>
            </Card>
            <br></br>
                    <br></br>
          </Col>
        </Row>
    </Container>
    </>
  );
}
export default EditarActividad;
